// extracted by mini-css-extract-plugin
export var select = "_qy-0";